import PropTypes from "prop-types";
import React, { Fragment, useMemo } from "react";
import ShopTopAction from "../../components/product/ShopTopAction";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLang from "../../hooks/use-lang";

const ShopTopbar = ({
    getLayout,
    getFilterSortParams,
    productCount,
    sortedProductCount,
}) => {
    const { t } = useTranslation();
    const { getLangValue } = useLang();
    const { categories } = useSelector((state) => state.category);
    const { category_id } = useParams();

    const sub_categories = useMemo(() => {
        if (!category_id) return [];

        let found_category = categories.find((c) => c.id == category_id);

        if (found_category) {
            return found_category?.sub_categories || [];
        } else {
            for (var i = 0; i < categories.length; i++) {
                if (
                    categories[i].sub_categories.find(
                        (sc) => sc.id == category_id
                    )
                ) {
                    return categories[i].sub_categories || [];
                }
            }
        }
        return [];
    }, [categories, category_id]);

    return (
        <Fragment>
            <div className="category-tags">
                {sub_categories.map((sc) => {
                    return (
                        <Link
                            key={sc.id}
                            to={
                                process.env.PUBLIC_URL +
                                (category_id == sc.id
                                    ? `/shop/${sc.parent_primary_category_id}`
                                    : `/shop/${sc.id}`)
                            }
                            className={`category-tag ${
                                category_id == sc.id ? "active" : ""
                            }`}
                        >
                            {getLangValue(sc, "category_name")}
                        </Link>
                    );
                })}
            </div>
            {/* shop top action */}
            <ShopTopAction
                getLayout={getLayout}
                getFilterSortParams={getFilterSortParams}
                productCount={productCount}
                sortedProductCount={sortedProductCount}
            />
        </Fragment>
    );
};

ShopTopbar.propTypes = {
    getFilterSortParams: PropTypes.func,
    getLayout: PropTypes.func,
    productCount: PropTypes.number,
    sortedProductCount: PropTypes.number,
};

export default ShopTopbar;
